import { usePlanIsRequest as useIsRequest } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-request/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsRequest = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isRequest } = viewModel;

	return useIsRequest({
		isRequest,
		onSetViewModel,
	});
};
